import { __awaiter, __decorate, __metadata } from "tslib";
import { isEqual } from 'lodash';
import { inject, injectable, postConstruct } from 'mana-syringe';
import { XFlowGraphCommands, XFlowNodeCommands, XFlowEdgeCommands, XFlowGroupCommands, } from '../constant';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
export var NsGraphUtils;
(function (NsGraphUtils) {
    function isNodeEqual(curNodeConfig, nextNodeConfig) {
        /** XFlow默认的判断节点是否相等的逻辑 */
        return isEqual(curNodeConfig, nextNodeConfig);
    }
    NsGraphUtils.isNodeEqual = isNodeEqual;
    function isEdgeEqual(curEdgeConfig, nextEdgeConfig) {
        /** XFlow默认的判断边是否相等的逻辑 */
        return isEqual(curEdgeConfig, nextEdgeConfig);
    }
    NsGraphUtils.isEdgeEqual = isEdgeEqual;
})(NsGraphUtils || (NsGraphUtils = {}));
export var NsGraphRender;
(function (NsGraphRender) {
    /** Command: 用于注册named factory */
    NsGraphRender.command = XFlowGraphCommands.GRAPH_RENDER;
    /** hookName */
    NsGraphRender.hookKey = 'graphRender';
})(NsGraphRender || (NsGraphRender = {}));
let GraphRenderCommand = class GraphRenderCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.graphRender.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const graphMeta = yield this.ctx.getGraphMeta();
                const { beforeRender, graphData, isNodeEqual, isEdgeEqual, afterRender } = handlerArgs;
                /** 如果用户自定义beforeRender方法 */
                beforeRender && beforeRender(graphMeta);
                yield this.doLoadGraph(x6Graph, graphData, isNodeEqual, isEdgeEqual);
                /** 如果用户自定义afterRender方法 */
                afterRender && afterRender(graphData, graphMeta);
                return {};
            }), runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
        this.doLoadGraph = (x6Graph, graphData, isNodeEqual, isEdgeEqual) => __awaiter(this, void 0, void 0, function* () {
            if (!(x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.isFrozen())) {
                x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.freeze();
            }
            const commandService = this.ctx.getCommands();
            const { addNodeConfigs, addEdgeConfigs, 
            // retainNodes,
            // retainEdges,
            removeNodes, removeEdges, updateNodes, updateEdges, } = this.graphDataDiff(x6Graph, graphData, isNodeEqual, isEdgeEqual);
            /** 更新节点/边 */
            for (const updateNode of updateNodes) {
                const nodeData = updateNode === null || updateNode === void 0 ? void 0 : updateNode.getData();
                yield commandService.executeCommand(XFlowNodeCommands.UPDATE_NODE.id, {
                    nodeConfig: nodeData,
                });
            }
            for (const updateEdge of updateEdges) {
                const edgeData = updateEdge === null || updateEdge === void 0 ? void 0 : updateEdge.getData();
                yield commandService.executeCommand(XFlowEdgeCommands.UPDATE_EDGE.id, {
                    edgeConfig: edgeData,
                });
            }
            /** 新增节点/边 */
            for (const nodeConfig of addNodeConfigs) {
                yield commandService.executeCommand(XFlowNodeCommands.ADD_NODE.id, {
                    nodeConfig,
                    options: {
                        isRenderGraph: true,
                    },
                }, {
                    name: 'remove servcie',
                    handler: (args) => __awaiter(this, void 0, void 0, function* () {
                        delete args.createNodeService;
                    }),
                });
            }
            yield commandService.executeCommand(XFlowGroupCommands.INIT_GROUP.id, {
                graphData: { nodes: addNodeConfigs, edges: [] },
            });
            for (const edgeConfig of addEdgeConfigs) {
                yield commandService.executeCommand(XFlowEdgeCommands.ADD_EDGE.id, {
                    edgeConfig,
                    options: {
                        isRenderGraph: true,
                    },
                }, {
                    name: 'remove servcie',
                    handler: (args) => __awaiter(this, void 0, void 0, function* () {
                        delete args.createEdgeService;
                    }),
                });
            }
            /** 删除节点/边/群组 */
            for (const removeNode of removeNodes) {
                const nodeData = removeNode === null || removeNode === void 0 ? void 0 : removeNode.getData();
                if (nodeData.isGroup) {
                    yield commandService.executeCommand(XFlowGroupCommands.DEL_GROUP.id, {
                        nodeConfig: nodeData,
                    });
                }
                else {
                    yield commandService.executeCommand(XFlowNodeCommands.DEL_NODE.id, { nodeConfig: nodeData });
                }
            }
            for (const removeEdge of removeEdges) {
                const edgeData = removeEdge === null || removeEdge === void 0 ? void 0 : removeEdge.getData();
                yield commandService.executeCommand(XFlowEdgeCommands.DEL_EDGE.id, { edgeConfig: edgeData });
            }
            if (x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.isFrozen()) {
                x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.unfreeze();
            }
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
    /**
     * 画布内容Diff
     * @param x6Graph x6画布实例
     * @param graphData 画布数据
     * @param isNodeEqual 允许用户自定义判断节点是否相等
     * @param isEdgeEqual 允许用户自定义判断边是否相等
     */
    graphDataDiff(x6Graph, graphData, isNodeEqual, isEdgeEqual) {
        const { nodes: nodeConfigs, edges: edgeConfigs } = graphData;
        /** 新增节点数据 */
        const addNodeConfigs = [];
        nodeConfigs.forEach(nodeConfig => {
            const findNode = x6Graph.getCellById(nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.id);
            if (!findNode) {
                addNodeConfigs.push(nodeConfig);
            }
        });
        /** 保持、更新、移除节点 */
        const retainNodes = [];
        const updateNodes = [];
        const removeNodes = [];
        const allNodes = x6Graph.getNodes();
        allNodes.forEach(x6Node => {
            const findNodeConfig = nodeConfigs.find(nodeConfig => (nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.id) === (x6Node === null || x6Node === void 0 ? void 0 : x6Node.id));
            if (!findNodeConfig) {
                removeNodes.push(x6Node);
            }
            else {
                let judgeResult = true;
                if (isNodeEqual) {
                    /** 如果用户自定义节点是否相等的方法 */
                    judgeResult = isNodeEqual(x6Node === null || x6Node === void 0 ? void 0 : x6Node.data, findNodeConfig);
                }
                else {
                    /** XFlow默认的判断节点是否相等的逻辑 */
                    if ((x6Node === null || x6Node === void 0 ? void 0 : x6Node.data) && findNodeConfig) {
                        judgeResult = NsGraphUtils.isNodeEqual(x6Node === null || x6Node === void 0 ? void 0 : x6Node.data, findNodeConfig);
                    }
                }
                if (!judgeResult) {
                    x6Node.setData(findNodeConfig, {
                        deep: false,
                    });
                }
                judgeResult === true ? retainNodes.push(x6Node) : updateNodes.push(x6Node);
            }
        });
        /** 新增边数据 */
        const addEdgeConfigs = [];
        edgeConfigs.forEach(edgeConfig => {
            const findEdge = x6Graph.getCellById(edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.id);
            if (!findEdge) {
                addEdgeConfigs.push(edgeConfig);
            }
        });
        /** 保持、更新、移除节点 */
        const retainEdges = [];
        const updateEdges = [];
        const removeEdges = [];
        const allEdges = x6Graph.getEdges();
        allEdges.forEach(x6Edge => {
            const findEdgeConfig = edgeConfigs.find(edgeConfig => (edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.id) === (x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.id));
            if (!findEdgeConfig) {
                removeEdges.push(x6Edge);
            }
            else {
                let judgeResult = true;
                if (isEdgeEqual) {
                    /** 如果用户自定义边是否相等的方法 */
                    judgeResult = isEdgeEqual(x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.data, findEdgeConfig);
                }
                else {
                    /** XFlow默认的判断边是否相等的逻辑 */
                    if ((x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.data) && findEdgeConfig) {
                        judgeResult = NsGraphUtils.isEdgeEqual(x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.data, findEdgeConfig);
                    }
                }
                if (!judgeResult) {
                    x6Edge.setData(findEdgeConfig, {
                        deep: false,
                    });
                }
                judgeResult === true ? retainEdges.push(x6Edge) : updateEdges.push(x6Edge);
            }
        });
        return {
            addNodeConfigs,
            addEdgeConfigs,
            retainNodes,
            retainEdges,
            removeNodes,
            removeEdges,
            updateNodes,
            updateEdges,
        };
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphRenderCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphRenderCommand.prototype, "init", null);
GraphRenderCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphRender.command.id },
    })
    /** 画布渲染命令 */
], GraphRenderCommand);
export { GraphRenderCommand };
//# sourceMappingURL=graph-render.js.map